// extracted by mini-css-extract-plugin
export default {"stickyButton":"stickyButton--N1tJz","hide":"hide--DKvIK","right":"right--49r+S","left":"left--P9PaZ","bottom":"bottom--GUde+","shadow":"shadow--k3zdx"};